<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-19 15:09:42
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-19 15:10:00
-->
<template>
    <router-view />
</template>

<script>
export default {
	name: 'ProductView',
};
</script>